import React__default, { useRef, useContext, createRef } from 'react';
import { NavLink } from 'react-router-dom';
import './List.scss.js';
import { MenuContext } from '../Menu.js';
import { classnames } from '../../../../utils/classnames.js';
import Tooltip from '../../Tooltip/Tooltip.js';

var List = function List(_ref) {
  var list = _ref.list,
      _ref$tooltipBackgroun = _ref.tooltipBackground,
      tooltipBackground = _ref$tooltipBackgroun === void 0 ? 'white' : _ref$tooltipBackgroun,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size;

  /** Ссылки на элементы списка */
  var refs = useRef([]);

  var onElementClick = function onElementClick(e, li) {
    e.stopPropagation();
    !li.url && e.preventDefault();
    li.handler && li.handler();
    onClose && onClose();
  };

  var _useContext = useContext(MenuContext),
      onClose = _useContext.onClose;

  var checkOverflow = function checkOverflow(index) {
    var el = refs.current[index].current;

    if (!el) {
      return;
    }

    var isOverflowing = (el === null || el === void 0 ? void 0 : el.clientWidth) < el.scrollWidth || (el === null || el === void 0 ? void 0 : el.clientHeight) < el.scrollHeight;
    return isOverflowing;
  };

  var renderLabel = function renderLabel(index, label) {
    return checkOverflow(index) ? /*#__PURE__*/React__default.createElement(Tooltip, {
      background: tooltipBackground,
      position: "bottom",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-v-6e52f9c7": ""
    }, label), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, label)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, label);
  };

  var listElementJSX = list === null || list === void 0 ? void 0 : list.map(function (li, i) {
    var disabledClass = li.disabled ? 'rf-list__element--disabled' : '';
    var separatedClass = li.separated ? 'rf-list__element--separated' : '';

    if (!refs.current[i]) {
      refs.current[i] = /*#__PURE__*/createRef();
    }

    return /*#__PURE__*/React__default.createElement("li", {
      className: "rf-li",
      key: li.value || i,
      "data-v-6e52f9c7": ""
    }, li.separated && /*#__PURE__*/React__default.createElement("div", {
      className: "rf-list__separator",
      "data-v-6e52f9c7": ""
    }), li.url ? /*#__PURE__*/React__default.createElement(NavLink, {
      innerRef: refs.current[i],
      to: li.url,
      className: classnames('rf-list__element', disabledClass, separatedClass),
      onClick: function onClick(e) {
        return onElementClick(e, li);
      },
      "data-v-6e52f9c7": ""
    }, renderLabel(i, li.label)) : /*#__PURE__*/React__default.createElement("div", {
      ref: refs.current[i],
      className: classnames('rf-list__element', disabledClass, separatedClass, li.isTitle && 'rf-list__element--title'),
      onClick: function onClick(e) {
        return !li.isTitle && onElementClick(e, li);
      },
      "data-v-6e52f9c7": ""
    }, renderLabel(i, li.label)));
  }); // -------------------------------------------------------------------------------------------------------------------

  return /*#__PURE__*/React__default.createElement("ul", {
    className: "rf-list rf-list--size-".concat(size),
    "data-testid": "rf-list",
    "data-v-6e52f9c7": ""
  }, listElementJSX);
};

export { List as default };
